<template lang="pug">
  multiselect(
    class="multiselect-select"
    v-model="value",
    :options="options",
    :searchable="false",
    :show-labels="false"
    :placeholder="placeholder"
    :multiple="multiple"
    label="label"
    track-by="value"
  )
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Sélectionner'
    },
    options: {
      type: Array,
      default: () => [
        {
          label: 'option 1',
          value: 'option1-value'
        },
        {
          label: 'option 2',
          value: 'option2-value'
        },
        {
          label: 'option 3',
          value: 'option3-value'
        },
        {
          label: 'option 4',
          value: 'option4-value'
        },
        {
          label: 'option 5',
          value: 'option5-value'
        },
        {
          label: 'option 6',
          value: 'option6-value'
        }
      ]
    }
  },
  data () {
    return {
      value: ''
    }
  }
}
</script>
